angular.module('ihestiaRestServicesBase')

/**
 * klauzule produktowe
 */
  .service('offersApkSvc', ['IHestiaRestServiceAbstractDef', function(IHestiaRestServiceAbstractDef) {

    /**
     * Główny konstruktor
     */
    var OffersApkSvc = function() {
      IHestiaRestServiceAbstractDef.apply(this, arguments);
      var self = this;
      this.resource = 'offers';
      this.businessArea = 'insurance';
      this.port = '8201';
      this.path = 'RestApplications';
      this.apiVersion = 'v2';

      /**
       * pobranie klauzul produktowych dla wniosku
       *
       * @param {String} id
       * @param {String} appMode
       * @param {String} offerId
       * @param {Object} data
       * @param {function} callback
       * @returns {*}
       */
      this.getOfferDetails = function(offerLink, callback, errorCallback, httpParams) {
        if(typeof httpParams === 'undefined' || httpParams === null)
        {
          httpParams = {};
        }

        httpParams.allowedStatuses = [403, 404, 409, 500];
        var data = {
          offerLink: offerLink
        };
        return self.post(null, data, 'apk', callback, errorCallback, httpParams);
      };

    };
    
    return new OffersApkSvc();
  }]);